import script from "./AccountInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountInfo.vue?vue&type=script&setup=true&lang=js"

import "./AccountInfo.vue?vue&type=style&index=0&id=ecca4aa6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ecca4aa6"]])

export default __exports__